import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import ApiService from "../../../ApiService";
import { Spinner } from "react-bootstrap";
import ReactQuill from "react-quill";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function ClinicianTemplates({}) {
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [templateId, setTemplateId] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  //Snackbar State
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  useEffect(() => {
    getTemplates();
  }, []);

  const getTemplates = async () => {
    try {
      const response = await ApiService.getClinicianTemplates();
      if (response.status === 200) {
        setTemplates(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const createTemplate = async () => {
    if (loading) return;
    try {
      setLoading(true);
      const data = {
        name: templateName,
        description: templateDescription
      };
      const response = await ApiService.addClinicianTemplate(data);
      if (response.status === 200) {
        // alert("Template Created Successfully");
        setSnackText("Template Created Successfully");
        setSnackSeverity("success");
        setSnackOpen(true);
      }
    } catch (error) {
      console.log(error);
      setSnackText(error.response.data.message || "Failed to create template");
      setSnackSeverity("error");
      setSnackOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const updateTemplate = async () => {
    if (loading) return;
    try {
      setLoading(true);
      const data = {
        id: templateId,
        name: templateName,
        description: templateDescription
      };
      const response = await ApiService.updateClinicianTemplate(data);
      if (response.status === 200) {
        setSnackText("Template Updated Successfully");
        setSnackSeverity("success");
        setSnackOpen(true);
      } else {
        setSnackText("Template Updated Failed");
        setSnackSeverity("error");
        setSnackOpen(true);
      }
    } catch (error) {
      console.log(error);
      setSnackText(error.response.data.message || "Failed to update template");
      setSnackSeverity("error");
      setSnackOpen(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Col style={{ flex: 2.25 }}>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
      <Row style={spaceOut}>
        <div
          style={{
            fontSize: 28,
            color: "rgba(0, 127, 97, 1)",
            textTransform: "capitalize",
            fontFamily: "GT Super Display",
            fontWeight: "500",
            marginTop: 60
          }}
        >
          Manage Templates
        </div>
      </Row>
      <Row style={spaceOut}>
        <Form.Group className="mb-3 mt-3 w-50 ">
          {/* <Form.Label>Templates</Form.Label> */}
          <Form.Select
            style={customSelectStyle}
            aria-label="Default select example"
            value={templateId || ""}
            onChange={e => {
              const selectedTemplate = templates.find(template => template.id === e.target.value);
              if (selectedTemplate) {
                setTemplateName(selectedTemplate.name);
                setTemplateDescription(selectedTemplate.description);
                setTemplateId(selectedTemplate.id);
              }
            }}
          >
            <option value={""}>Select Template</option>
            {templates.map((template, index) => {
              return (
                <option key={index} value={template.id}>
                  {template.name}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "left",
            width: "20%",
            cursor: "pointer",
            marginLeft: "10px"
          }}
        >
          {templateId && (
            <span
              className="resetText"
              onClick={() => {
                setTemplateId(null);
                setTemplateName("");
                setTemplateDescription("");
              }}
            >
              Reset
            </span>
          )}
        </div>
      </Row>
      <Row style={spaceOut}>
        <Form.Group className="mb-3 mt-3  w-50">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            defaultValue={templateName || ""}
            placeholder="Enter Template Name"
            onChange={e => setTemplateName(e.target.value)}
          />
        </Form.Group>
      </Row>
      <Row
        style={{
          ...spaceOut
        }}
      >
        <Form.Group className="mb-3 mt-3 w-100">
          <Form.Label>Content</Form.Label>
          {/* <Form.Control
            className="w-100"
            as="textarea"
            rows={10}
            defaultValue={templateDescription || ""}
            placeholder="Enter Template Name"
            onChange={e => setTemplateDescription(e.target.value)}
          /> */}
          <div>
            <style>
              {`
                          .ql-editor {
                             min-height: 300px; 
                             max-height:300px;
                             background-color: #fff;
                          }
                      `}
            </style>

            <ReactQuill
              theme="snow"
              value={templateDescription}
              onChange={value => {
                setTemplateDescription(value);
              }}
            />
          </div>
        </Form.Group>
      </Row>
      {templateId ? (
        <Button
          style={{
            width: 180,
            height: 40,
            marginLeft: 20,
            borderRadius: 8,
            backgroundColor: "rgba(0, 127, 97, 1)",
            fontSize: 20,
            fontWeight: "600",
            lineHeight: "100%",
            color: "rgba(253, 250, 241, 1)",
            border: "none",
            marginRight: 40,
            letterSpacing: 1.5
          }}
          onClick={updateTemplate}
        >
          {loading ? (
            <div
              style={{
                position: "relative"
              }}
            >
              <Row style={container}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </Row>
            </div>
          ) : (
            "Update"
          )}
        </Button>
      ) : (
        <Button
          style={{
            width: 180,
            height: 40,
            marginLeft: 20,
            borderRadius: 8,
            backgroundColor: "rgba(0, 127, 97, 1)",
            fontSize: 20,
            fontWeight: "600",
            lineHeight: "100%",
            color: "rgba(253, 250, 241, 1)",
            border: "none",
            marginRight: 40,
            letterSpacing: 1.5
          }}
          onClick={createTemplate}
        >
          {loading ? (
            <div
              style={{
                position: "relative"
              }}
            >
              <Row style={container}>
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </Row>
            </div>
          ) : (
            "Create"
          )}
        </Button>
      )}
    </Col>
  );
}

const spaceOut = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  textAlign: "left"
};

const customSelectStyle = {
  borderColor: "#ced4da",
  boxShadow: "inset 0 1px 2px rgb(0 0 0 / 8%)",
  padding: ".375rem .75rem",
  fontSize: "1rem",
  fontWeight: "400",
  lineHeight: "1.5",
  color: "#495057",
  backgroundColor: "#fff",
  border: "1px solid #ced4da",
  borderRadius: ".25rem",
  transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  width: "100%"
};
const container = {
  background: "rgba(255,255,255,0.5)",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 100000
};
